<template>
  <WorkspaceLayout>
    <div class="project-list">
      <div class="head">
        <div class="title">
          <h3>项目列表</h3>
          <div style="display: inline;">
            <div style="display: inline-block">
              排序方式
              <Select v-model="order" style="width:200px" @on-change="fetchData">
                <Option v-for="item in orderList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </div>
            <div style="display: inline-block;margin-left: 20px">
              <Input v-model="keyword" placeholder="请输入关键词搜索" suffix="ios-search" search @on-search="fetchData" />
            </div>
          </div>
        </div>

        <div class="filters">
          <template v-if="$route.name === 'PublicSea'">
            <Row class="row" :gutter="24">
              <Col :xs="24" :xl="12" :xxl="12">
              <span class="label">应用行业</span>
              <div class="filter">
                <Select v-model="filters.industryAreas" multiple @on-change="filterChange" placeholder="不限">
                  <Option v-for="item in industries" :value="item" :key="item">{{ item }}</Option>
                </Select>
              </div>
              </Col>
              <Col :xs="24" :xl="12" :xxl="12">
              <span class="label">所在地</span>
              <div class="filter">
                <Cascader v-model="filters.location" :data="areaOptions" placeholder="不限" change-on-select @on-change="locationChange"></Cascader>
              </div>
              </Col>
            </Row>
            <Row class="row" :gutter="24">
              <Col :xs="24" :xl="12" :xxl="12">
              <span class="label">期望合作方类型</span>
              <div class="filter">
                <Select v-model="filters.expectedPartners" multiple placeholder="不限" @on-change="filterChange">
                  <Option v-for="item in partnerTypes" :value="item" :key="item">{{ item }}</Option>
                </Select>
              </div>
              </Col>
              <Col :xs="24" :xl="12" :xxl="12">
              <span class="label">所属组织机构</span>
              <div class="filter">
                <Select v-model="filters.organization" placeholder="不限" @on-change="filterChange">
                  <Option v-for="(item, index) in collegesOptions" :value="item.name" :key="index">{{ item.name }}</Option>
                </Select>
              </div>
              </Col>
            </Row>
          </template>
        </div>
      </div>

      <div class="main">
        <a-list
          itemLayout="vertical"
          size="large"
          :loading="loading"
          :grid="{ gutter: 16, xs: 1, sm: 1, md: 2, lg: 3, xl: 3, xxl: 4 }"
          :dataSource="projects"
        >
          <a-list-item slot="renderItem" slot-scope="item">
            <ProjectItem :data="item" :key="item.id"></ProjectItem>
          </a-list-item>
        </a-list>
      </div>

      <div class="foot">
        <a-pagination
          :current="pagination.pageNo"
          :total="pagination.count"
          :pageSize="pagination.pageSize"
          @change="pageChange"
        />
      </div>
    </div>
  </WorkspaceLayout>
</template>

<script>
import options from '@/components/IndustryAreaSelector/options.json'
import { areaOptions } from '@/utils/constants/area'
import { partnerTypes } from '@/utils/constants/options'
import { Colleges, Projects } from '@/resources'
import _ from 'lodash'
import WorkspaceLayout from '@/components/page/WorkspaceLayout'
import ProjectItem from '@/components/ProjectItem'

export default {
  components: {
    WorkspaceLayout,
    ProjectItem
  },
  data () {
    return {
      loading: false,
      orderList: [
        {
          value: 'createdAt',
          label: '按创建时间'
        },
        {
          value: 'updatedAt',
          label: '按更新时间'
        },
        {
          value: 'participantsCount',
          label: '按参与人数'
        },
        {
          value: 'favoritedCount',
          label: '按收藏数'
        }
      ],
      order: 'createdAt',
      keyword: null,
      pagination: {
        pageNo: 1,
        pageSize: 12,
        count: 0
      },
      areaOptions,
      partnerTypes,
      projects: [],
      filters: {},
      colleges: []
    }
  },
  computed: {
    config () {
      const vm = this
      let config
      switch (vm.$route.name) {
        case 'projectManagementList':
          config = {
            api: 'listInCollege'
          }
          break
        case 'PublicSea':
          config = {
            api: 'listInPublicSea'
          }
          break
      }
      return config
    },
    industries () {
      return options.map(item => item.label)
    },
    collegesOptions () {
      return this.colleges.map(college => ({ id: college.id, name: college.name }))
    }
  },
  watch: {
    $route () {
      this.fetchData()
    }
  },
  created () {
    Promise.all([this.fetchData(), this.fetchColleges()])
      .catch(err => this.$message.error(err))
  },
  methods: {
    pageChange (current) {
      const vm = this
      vm.pagination.pageNo = current
      vm.fetchData()
    },
    locationChange (value, selectedData) {
      this.filters.location = value
      this.filterChange()
    },
    filterChange () {
      this.pagination.pageNo = 1
      this.fetchData()
    },
    async fetchColleges () {
      const { colleges } = await Colleges.list()
      this.colleges = colleges
    },
    async fetchData () {
      const params = _.cloneDeep(this.filters)
      Object.keys(params).forEach(key => {
        if (Array.isArray(params[key])) params[key] = params[key].join(',')
        if (!params[key]) Reflect.deleteProperty(params, key)
      })
      if (this.keyword) params.text = this.keyword

      try {
        this.loading = true
        const { projects, count } = await Projects[this.config.api]({ order: this.order, ...this.pagination, ...params })
        this.projects = projects
        this.pagination.count = count
      } catch (err) {
        this.$message.error('获取失败', err)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  $base-margin-bottom: 4px

  .head
    background-color: #fff
    border-radius: 2px
    padding: 20px 20px 0px 20px
    margin-bottom: 16px
    .title
      height: 46px
      border-bottom: 1px solid #eee
      display: flex
      justify-content: space-between
      h3
        font-weight: 700
        color: #666
    .filters
      padding: 20px 0
      margin-bottom: 8px
      .row
        &:not(:last-child)
          margin-bottom: $base-margin-bottom
      .label
        display: inline-block
        text-align: left
        margin-bottom: $base-margin-bottom / 2
      .filter
        display: inline-block
        width: 100%

  .main
    background: inherit

  .foot
    margin: 15px 0
    text-align: right
</style>
